import React from 'react';
import { ShieldCheck, Star, Lock } from 'lucide-react';
export function TrustFooter() {
  return <footer className="fixed bottom-0 left-0 right-0 z-40 w-full bg-white border-t border-gray-200 py-1.5 sm:py-3" data-id="element-192">
      <div className="max-w-4xl mx-auto px-4" data-id="element-193">
        <div className="flex items-center justify-center gap-4 sm:gap-10 text-gray-500" data-id="element-194">
          <div className="flex items-center gap-1.5" data-id="element-195">
            <div className="bg-blue-50 p-1.5 rounded-full" data-id="element-196">
              <ShieldCheck className="w-4 h-4 text-primary" data-id="element-197" />
            </div>
            <div className="flex flex-col" data-id="element-198">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-199">BBB</span>
              <span className="text-[10px] font-semibold text-primary" data-id="element-200">A+</span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-201">
            <div className="bg-green-50 p-1.5 rounded-full" data-id="element-202">
              <Star className="w-4 h-4 text-green-500 fill-green-500" data-id="element-203" />
            </div>
            <div className="flex flex-col" data-id="element-204">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-205">
                Trustpilot
              </span>
              <span className="text-[10px] font-semibold text-green-600" data-id="element-206">
                4.8/5.0
              </span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-207">
            <div className="bg-gray-100 p-1.5 rounded-full" data-id="element-208">
              <Lock className="w-4 h-4 text-gray-600" data-id="element-209" />
            </div>
            <div className="flex flex-col" data-id="element-210">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-211">SSL</span>
              <span className="text-[10px]" data-id="element-212">256-bit</span>
            </div>
          </div>
        </div>
        <p className="hidden sm:block text-center text-[10px] text-gray-400 mt-2" data-id="element-213">
          Tu información está protegida con cifrado de 256 bits.
        </p>
      </div>
    </footer>;
}